import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Html5Qrcode } from 'html5-qrcode';
import { scanAttendance } from '../../services/api';
import { FiCamera, FiCheck, FiX, FiRefreshCw } from 'react-icons/fi';

const MarkAttendance = () => {
  const { t } = useTranslation();
  const scannerInstance = useRef(null);
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const stop = async () => {
    try { if (scannerInstance.current?.isScanning) await scannerInstance.current.stop(); } catch {}
    try { await scannerInstance.current?.clear(); } catch {}
    scannerInstance.current = null;
    setScanning(false);
  };

  const start = async () => {
    setError(null);
    setResult(null);
    setScanning(true);

    setTimeout(async () => {
      try {
        scannerInstance.current = new Html5Qrcode('attend-qr-reader');
        await scannerInstance.current.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 240, height: 240 } },
          async (decoded) => {
            await stop();
            try {
              const r = await scanAttendance(decoded);
              setResult(r.data);
            } catch (e) {
              setError(e.response?.data?.error || t('markAttendance.failedMark'));
            }
          },
          () => {}
        );
      } catch (e) {
        setError(t('markAttendance.cameraDenied'));
        setScanning(false);
      }
    }, 100);
  };

  useEffect(() => () => { stop(); }, []);

  return (
    <div className="page-content">
      <div className="page-header"><div><h1>{t('markAttendance.title')}</h1><p>{t('markAttendance.description')}</p></div></div>

      {!scanning && !result && (
        <div className="card">
          <div className="card-body" style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📷</div>
            <h3 style={{ marginBottom: 8 }}>{t('markAttendance.readyToScan')}</h3>
            <p style={{ color: '#6b7280', marginBottom: 20 }}>{t('markAttendance.pointCamera')}</p>
            <button className="btn btn-primary" onClick={start}><FiCamera /> {t('markAttendance.startCamera')}</button>
            {error && <div style={{ color: '#dc2626', marginTop: 16, fontSize: 13 }}>{error}</div>}
          </div>
        </div>
      )}

      {scanning && (
        <div className="card">
          <div className="card-body">
            <div id="attend-qr-reader" style={{ width: '100%', maxWidth: 400, margin: '0 auto' }} />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
              <button className="btn btn-secondary" onClick={stop}><FiX /> {t('common.cancel')}</button>
            </div>
          </div>
        </div>
      )}

      {result && (
        <div className="card">
          <div className="card-body" style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 56, color: '#16a34a', marginBottom: 12 }}><FiCheck style={{ display: 'inline' }} /></div>
            <h2 style={{ marginBottom: 8 }}>{result.already ? t('markAttendance.alreadyMarked') : t('markAttendance.welcomeMarked')}</h2>
            <p style={{ color: '#6b7280', marginBottom: 4 }}><strong>{result.service?.name}</strong></p>
            <p style={{ color: '#6b7280', marginBottom: 24 }}>{result.service?.date}</p>
            <button className="btn btn-secondary" onClick={start}><FiRefreshCw /> {t('markAttendance.scanAgain')}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarkAttendance;
